import { gql } from "@apollo/client";

export const getReInsurers = gql`
  query Reinsurers {
    count: getReinsurersCount
    rows: reinsurers {
      re_abbrv
      re_company_email
      re_company_name
      re_company_website
      reinsurer_address {
        country
        region
        reinsurer_address_id
        street
        suburb
      }
      reinsurer_id
      reinsurer_representatives {
        reinsurer_representative_id
      }
      kava_premium_member {
        kava_premium_member_id
        membership_status
      }
    }
  }
`;

export const getReinsurerOfferPayments = gql`
  query GetReinsurerParticipantPayments($offerParticipantId: ID) {
    getReinsurerParticipantPayments(offer_participant_id: $offerParticipantId) {
      offer_participant_payment_id
      offer_payment_amount
      paid_details
      offer_participant_payment_comment
      payment_status
      created_at
      updated_at
      offer_deduction_charge {
        offer_deduction_payment_id
        nic_levy_paid
        withholding_tax_paid
        brokerage_amount_paid
        commission_taken
      }
    }
  }
`;
export const getReinsurerOfferPayment = gql`
  query GetReinsurerParticipantPayment($participant_payment_id: ID) {
    getReinsurerParticipantPayment(
      participant_payment_id: $participant_payment_id
    ) {
      offer_participant_payment_id
      offer_payment_amount
      paid_details
      offer_participant_payment_comment
      payment_status
      created_at
      updated_at
      offer_deduction_charge {
        offer_deduction_payment_id
        nic_levy_paid
        withholding_tax_paid
        brokerage_amount_paid
        commission_taken
      }
    }
  }
`;

export const getReinsurerAssociates = gql`
  query GetReinsurerAssociates(
    $reinsurerId: ID!
    $pagination: Pagination
    $search: String
  ) {
    getReinsurerAssociates(
      reinsurer_id: $reinsurerId
      pagination: $pagination
      search: $search
    ) {
      reinsurer_representative_id
      reinsurersreinsurer_id
      rep_first_name
      rep_last_name
      rep_primary_phonenumber
      rep_secondary_phonenumber
      rep_email
      position
      reinsurer {
        re_abbrv
        re_company_email
        re_company_name
        re_company_website
        reinsurer_id
      }
    }
    count: getReinsurerAssociatesCount(reinsurer_id: $reinsurerId)
  }
`;

export const getKavaPremiumMemberLimits = gql`
  query GetKavaPremiumMemberLimits(
    $premiumMemberId: ID!
    $limit: Int
    $offset: Int
  ) {
    count: getKavaPremiumMemberLimitsCount(premium_member_id: $premiumMemberId)
    rows: getKavaPremiumMemberLimits(
      premium_member_id: $premiumMemberId
      limit: $limit
      offset: $offset
    ) {
      created_at
      premium_member_limit_id
      participation_lower_limit
      premium_details
      created_by {
        employee_first_name
        employee_last_name
        emp_abbrv
      }
      updated_by {
        employee_id
        employee_first_name
        employee_email
        employee_last_name
      }
    }
  }
`;

export const getKavaPremiumMemberLimit = gql`
  query GetKavaPremiumMemberLimit($premiumMemberLimitId: ID!) {
    getKavaPremiumMemberLimit(premium_member_limit_id: $premiumMemberLimitId) {
      created_at
      created_by {
        employee_first_name
        employee_email
        employee_last_name
        employee_id
      }
      participation_lower_limit
      premium_details
      premium_member_limit_id
      updated_by {
        employee_last_name
        employee_id
        employee_email
        employee_first_name
      }
      premium_member {
        membership_status
        reinsurer {
          re_company_name
        }
      }
    }
  }
`;
export const getReInsurerRep = gql`
  query GetReinsurerRep($repId: ID) {
    getReinsurerRep(rep_id: $repId) {
      reinsurer_representative_id
      reinsurersreinsurer_id
      rep_first_name
      rep_last_name
      rep_primary_phonenumber
      rep_secondary_phonenumber
      rep_email
      position
    }
  }
`;

export const getReinsurerReps = gql`
  query GetReinsurerReps {
    getReinsurerReps {
      reinsurer_representative_id
      reinsurersreinsurer_id
      rep_first_name
      rep_last_name
      rep_primary_phonenumber
      rep_secondary_phonenumber
      rep_email
      position
      reinsurer {
        re_abbrv
        re_company_email
        re_company_name
      }
    }
  }
`;

export const getReInsurer = gql`
  query Reinsurer($reinsurerId: ID!) {
    reinsurer(reinsurer_id: $reinsurerId) {
      reinsurer_id
      re_company_name
      re_company_email
      re_company_website
      re_abbrv
      reinsurer_address {
        reinsurer_address_id
        street
        suburb
        region
        country
      }
      reinsurer_overview {
        brokerage_chart
        total_brokerage_amt
        total_closed
        total_fac_premium
        total_nic_tax
        total_paid
        total_pending
        total_unpaid
        total_withholding_tax
      }
      kava_premium_member {
        membership_status
        kava_premium_member_id
      }
    }
  }
`;
